import {Component, OnInit} from '@angular/core';
import {IotData, IotService} from '../iot.service';
import {Observable} from 'rxjs/Observable';
import * as Highcharts from 'highcharts';

Highcharts.setOptions({
  global: {
    timezoneOffset: 2 * 60
  }
});


@Component({
  selector: 'app-iot',
  templateUrl: './iot.component.html',
  styleUrls: ['./iot.component.css']
})
export class IotComponent implements OnInit {


  dataToShow = new Array<IotData>();
  graphData = new Map<String, Array<Object>>();
  aggByHourData = [];

  realTimeChart: any;

  realTimeChartOptions: Object;

  hourSummaryChartOptions: Object;

  saveRealTimeInstance(chartInstance) {
    this.realTimeChart = chartInstance;
  }

  constructor(private is: IotService) {
    this.is.getAll().subscribe((data: IotData[]) => {
      this.processAllData(data);
      this.realTimeChartOptions = {
        chart: {type: 'area', zoomType: 'x'},
        title: {text: 'Potência em função do Tempo'},
        subtitle: {
          text: 'Potência consumida em Watts pelo equipamento'
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: { // don't display the dummy year
            month: '%e. %b',
            year: '%b'
          },
          title: {
            text: 'Data'
          }
        },
        yAxis: {
          title: {
            text: 'Potência(Wh)'
          },
          min: 0
        },
        tooltip: {
          headerFormat: '<b>{series.name}</b><br>',
          pointFormat: '{point.x:%e. %b}: {point.y:.2f} Watts'
        },
        plotOptions: {
          area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#666666'
            }
          }
        },
        series: [{
          name: 'MAC deadbeeffeed',
          data: this.graphData.get('deadbeeffeed')
        }, {
          name: 'MAC 5ccf7f1855b',
          data: this.graphData.get('5ccf7f1855b2')
        }, {
          name: 'MAC 5ccf7f1962ec',
          data: this.graphData.get('5ccf7f1962ec')
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                enabled: false
              }
            }
          }]
        }
      };
      this.hourSummaryChartOptions = {
        title: {text: 'Consumo por Hora'},
        subtitle: {
          text: 'Wh medido no sensor'
        },
        xAxis: {
          categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12',
            '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
          title: {
            text: 'Hora'
          }
        },
        yAxis: {
          title: {
            text: 'Potência(Wh)'
          },
          min: 0
        },
        tooltip: {
          headerFormat: '<b>{series.name}</b><br>',
          pointFormat: '{point.x}h: {point.y:.2f} Watts'
        },
        series: [{
          name: 'Monitor AA:BB:CC:DD:EE:FF',
          data: this.aggByHourData
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                enabled: false
              }
            }
          }]
        }
      };
    });
  }

  processNewData(iotData: IotData[]) {
    const returnValue = new Array<IotData>();
    iotData.forEach((data: IotData) => {
      this.realTimeChart.series[0].addPoint([data.receivedDate, (data.value > 100) ? (127 * (data.value) / 19700) + 14 : 0]);
      returnValue.unshift(data);
    });
    this.dataToShow = returnValue.concat(this.dataToShow);
  }


  processAllData(iotData: IotData[]) {
    const returnValue = new Array<IotData>();
    iotData.forEach((data: IotData) => {
      returnValue.unshift(data);
      if (!this.graphData.get(data.mac)) {
        this.graphData.set(data.mac, []);
      }
      // this.graphData.get(data.mac).push([data.receivedDate, (data.value > 100) ? (127 * (data.value) / 19700) + 14 : 0]);
      this.graphData.get(data.mac).push([data.receivedDate, data.value]);
    });
    this.dataToShow = returnValue;

    this.aggByHourData = iotData.reduce((previousValue, currentValue, currentIndex, array) => {
      const date = new Date(currentValue.receivedDate);
      if (currentIndex > 0) {
        const previousIndex = array[currentIndex - 1];
        let potencia;
        let maxValue: IotData = null;
        let minValue: IotData = null;
        if (currentValue.value > previousIndex.value) {
          maxValue = currentValue;
          minValue = previousIndex;
        } else {
          maxValue = previousIndex;
          minValue = currentValue;
        }
        potencia = minValue.value * (currentValue.receivedDate - previousIndex.receivedDate) / 3600000 +
          ((maxValue.value - minValue.value) * (currentValue.receivedDate - previousIndex.receivedDate) / 2) / (3600000);
        console.log(`previousValue:${previousIndex.value} currentValue:${currentValue.value} 
        | tempo:${(currentValue.receivedDate - previousIndex.receivedDate)}ms potencia: ${potencia}`);
        previousValue[date.getHours()] = previousValue[date.getHours()] + Math.abs(potencia);
      }
      return previousValue;
    }, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  }

  ngOnInit() {
    Observable.interval(10000).flatMap((i: number) => {
      if (this.dataToShow) {
        return this.is.getAllFrom(this.dataToShow[0].id);
      } else {
        return Observable.empty();
      }
    }).subscribe((iotData: IotData[]) => {
      console.log(`Received data: ${JSON.stringify(iotData)}`);
      this.processNewData(iotData);
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/iot/iot.component.ts